import React, { useState } from "react";
import QuestionSearch from "./QuestionSearch";
import Element from "./Element";
import Telement from "./Telement";
import { useTranslation } from "react-i18next";
import { Search as SearchIcon } from "lucide-react";
import { Helmet } from "react-helmet";

const SearchPage: React.FC = () => {
  const { t } = useTranslation();
  const [elements, setElementsState] = useState<any[]>([]);
  const [opens, setOpens] = useState<any[]>([]);
  const [keywords, setKeywords] = useState<string[]>([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const toggleOpen = (question: any) => {
    setOpens(prev =>
      prev.includes(question) ? prev.filter(o => o !== question) : [...prev, question]
    );
  };

  const setElements = (data: any[], showAnswers: boolean, kws: string[]) => {
    setHasSearched(true);
    setIsEmpty(data.length === 0);
    setKeywords(kws);

    if (showAnswers) {
      const d: any[] = [];
      data.forEach(el => {
        if (el.question !== null) {
          d.push(el.question.values[0].id);
        } else if (el.theme !== null) {
          el.theme.values.forEach((_: any, tindex: number) => {
            d.push(`${el.theme.id}-${tindex}`);
          });
        }
      });
      setOpens(d);
    } else {
      setOpens([]);
    }
    setElementsState(data);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pt-16">
      <Helmet>
        <title>{t("search.searchPlaceholder")} | 3sual</title>
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-4">

        {/* Search form card */}
        <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 shadow-sm px-6 py-5">
          <div className="flex items-center gap-2 mb-5">
            <SearchIcon className="w-5 h-5 text-blue-500 flex-shrink-0 dark:text-indigo-300" />
            <h1 className="text-xl font-black text-gray-900 dark:text-gray-50">
              {t("search.searchPlaceholder")}
            </h1>
          </div>
          <QuestionSearch setElements={setElements} />
        </div>

        {/* Results card */}
        {hasSearched && (
          <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 shadow-sm px-6 py-5">
            {isEmpty ? (
              <p className="text-center text-gray-400 dark:text-gray-500 font-medium py-10">
                {t("search.noResults")}
              </p>
            ) : (
              elements.map((el, index) =>
                el.question !== null ? (
                  <Element
                    key={index}
                    opens={opens}
                    index={index}
                    toggleOpen={toggleOpen}
                    question={el.question}
                    keywords={keywords}
                    package={{ name: el.name, id: el.id }}
                  />
                ) : (
                  <Telement
                    key={index}
                    opens={opens}
                    index={index}
                    toggleOpen={toggleOpen}
                    khamsa={el.theme.raund === 5}
                    theme={el.theme}
                    keywords={keywords}
                    package={{ name: el.name, id: el.id }}
                  />
                )
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchPage;
